import * as constants from '../constants';
import store from '../store';

export const isUserRole = ({ admin = false, supervisor = false, dispatch = false, officer = false }) => {
  const currentUser = store.getState().auth.user;
  if (!currentUser) {
    return false;
  }
  const users = store.getState().users.byId;
  if (!users[currentUser.username]) {
    return false;
  }
  return ((admin && users[currentUser.username].role === constants.user.role.admin.value)
    || (supervisor && users[currentUser.username].role === constants.user.role.supervisor.value)
    || (dispatch && users[currentUser.username].role === constants.user.role.dispatch.value)
    || (officer && users[currentUser.username].role === constants.user.role.officer.value)
  );
};

export const getFormattedRole = role => {
  switch (role) {
    case constants.user.role.admin.value:
      return constants.user.role.admin.text;
    case constants.user.role.supervisor.value:
      return constants.user.role.supervisor.text;
    case constants.user.role.dispatch.value:
      return constants.user.role.dispatch.text;
    case constants.user.role.officer.value:
      return constants.user.role.officer.text;
    default:
      return role;
  }
};